<div class="astrea-home-banner">
    <a [routerLink]="currentBanner.url" [title]="currentBanner.title">
        <img [src]="currentImageSrc" [class.fade]="isFading" [alt]="currentBanner.title" />
    </a>
</div>
